import Pipes from "./pipes";

const ModuleName = "tfApp.js";

export default angular.module(ModuleName, [Pipes(ModuleName)])
                      .name;
